import React from 'react';
import { useSelector } from 'react-redux';
import FormSelect from 'shared/forms/FormSelect';
import { getWarehouseProducts } from 'src/slices/warehouseProducts';
import isNil from 'lodash/isNil';

const ProductsDropdown = ({ forcedData, ...props }) => {
  let products = !isNil(forcedData) ? forcedData : useSelector(getWarehouseProducts);
  products = products.map(({ id, productCode }) => ({ label: productCode, value: id }));

  return <FormSelect data={products} textField='label' dataItemKey='value' {...props} />;
};

export default ProductsDropdown;
